<template>
  <div class="box">
    <div v-if="showContent">
      <div class="level-left">
        <h4 class="mb-2 mb-md-0 subTitle">Filtros</h4>
      </div>
      <ContentLoading
        :show="showContent"
        :grid="grid"
        :width="300"
        :height="40"
        :mobile-grid="mobileGrid"
        :mobile-width="30"
        :mobile-height="15"
      />
      <p class="text-loading ml-2">Aguarde ...</p>
    </div>
    <div v-else>
      <nav class="level">
        <div class="level-left">
          <h4 class="mb-2 mb-md-0 subTitle">Filtros</h4>
        </div>
        <div class="d-flex flex-column flex-md-row justify-content-center align-items-end align-items-md-center">
            <div class="form-group w-100 mr-0 mr-md-3">
              <img @click="search(e = '')" class="search-icon" :src="require(`@/assets/icons/search.png`)">
              <input type="form-control"
                placeholder="Busque por nome da segmentação"
                @keypress="search($event)"
                v-model="filter"
              >
            </div>
          <div class="level-item mt-3 mt-md-0">
            <AppLink class="btnNew" tag="router-link"
                to="/create">
                Nova segmentação
            </AppLink>
            <AppLink class="btnImport" tag="router-link"
                to="/import">
                Importação
            </AppLink>
            <div class="itemIcon">
              <AppLink  to="/configurations"><b-icon icon="cog"></b-icon></AppLink>
            </div>
          </div>
        </div>
      </nav>
      <AppTable :data="docs" :columns="headers" :total="total" :limit="limit" :page="page" />
      <span class="d-flex m-3 justify-content-center" v-if="docs.length < 1">Nenhum resultado encontrado!</span>
    </div> 
    <Pagination
      :class="showContent ? 'hidden-pagination' : ''"
      v-if="pagination.pageCount > 1"
      :pagination="pagination"
      @update="fetch"
      class="pagination-list d-flex justify-content-center py-4"
      ref="pagination"
    />
  </div>
</template>

<script>
import { AppTable, AppLink } from '@/components'
import { getSegments } from '@/services/segments'
import Pagination from '@/components/helpers/Pagination'
import { mapActions } from 'vuex'
import config from '@/config'
import ContentLoading from '@/components/helpers/ContentLoading'

export default {
  name: 'SegmentsHome',
  components: {
    AppTable,
    AppLink,
    Pagination,
    ContentLoading
  },
  data: () => ({
    filter: null,
    docs: [],
    headers: [],
    page: 1,
    total: 1,
    // pages: 1,
    limit: 10,
    jobId: null,
    pagination: {
      pageCount: 0,
      totalCount: 0
    },
    showContent: true,
    grid: [
      { x: 100, y: 0, rx: 2, ry: 2, innerWidth: 100, innerHeight: 10 },
      { x: 205, y: 0, rx: 2, ry: 2, innerWidth: 70, innerHeight: 10 },
      { x: 280, y: 0, rx: 2, ry: 2, innerWidth: 20, innerHeight: 10 },
      { x: 0, y: 15, rx: 2, ry: 2, innerWidth: 300, innerHeight: 20 }
    ],
    mobileGrid: [
      { x: 0, y: 0, rx: 1, ry: 1, innerWidth: 30, innerHeight: 3 },
      { x: 9, y: 4, rx: 1, ry: 1, innerWidth: 15, innerHeight: 3 },
      { x: 25, y: 4, rx: 1, ry: 1, innerWidth: 5, innerHeight: 3 },
      { x: 0, y: 8, rx: 1, ry: 1, innerWidth: 30, innerHeight: 4 }
    ]
  }),
  created() {
    window.addEventListener('message', ({ data }) => {
       if ((event.origin.includes('8080') || event.origin.includes('8081') || event.origin.includes('adm')) && typeof data === 'string') {
         const { token, hashToken } = JSON.parse(`${data}`)
         this.setToken(token)
         this.setHashToken(hashToken)
         if (hashToken === config.tokenFrame) {
           this.setPage()
         }
       }
     })
    this.setPage()
  },
  methods: {
    ...mapActions(['setToken', 'setHashToken']),
    async fetch(page = 1) {
      try {
        this.showContent = true
        const { limit, jobId, filter } = this
        let filterLower = filter
        if(filterLower != null){
         filterLower = filter.toLowerCase()
        }
        const search = filterLower && [{ field: 'name', operator: 'ct', value: filterLower }]
        const response = await getSegments({ limit, page, jobId, filter: search })
        
        this.docs = response.data.docs
        const pages = response.data.pageCount
        const total = response.data.totalCount
        this.pagination = { 
          pageCount: pages, 
          totalCount: total 
        }
        this.jobId = response.data.jobId
      } catch (error) {
        console.log({ error })
      } finally {
        this.showContent = false
      }
    },
    setPage(newPage = null) {
      const query = this.$route.query
      if (query.page) this.page = Number(query.page)
      if (query.limit) this.limit = Number(query.limit)
      if (query.jobId) this.jobId = query.jobId
      if (query.filter) this.filter = query.filter
      if(newPage) this.page = newPage
      const { page, limit, jobId, filter } = this
      newPage && this.$router.push({ name: 'Home', query: { page, limit, jobId, filter } })
      this.fetch()
    },
    setFilter(page = 1) {
      const { limit, jobId, filter } = this
      let filterLower = filter.toLowerCase()
      if(filter === null || filter === '') {
        this.$router.replace({ query: {} }).catch(err => {
          err = ''
          console.log(err)
        })
        this.pagination = { 
          pageCount: 1
        }
        this.fetch()
        return
      }
      this.$router.replace({ query: { ...this.$route.query, page, limit, jobId, filterLower } }).catch(err => {
        err = ''
        console.log(err)
      })
      this.fetch()
    },
    capitalize(str){
      return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
    },
    async search(e) {
      this.jobId = null
      if(!e) this.setFilter()
      if(e.key === 'Enter') {
        this.setFilter()
      }
    }
  }
}
</script>

<style lang="scss">

.search{
  input{
    width: 312px;
    height: 40px;
  }
}
.itemIcon{
  padding-left: 10px;
  a { color: #6D6D77;
  }
}
.btnHeader{
  background: #2D9CDB;
  border-radius: 4px;
  color: #fff;
  width: 50px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.subTitle{
  font-weight: 500;
  font-size: 14px;
  color: #6D6D77;
  text-transform: uppercase;
}
.btnNew{
  background: #2D9CDB;
  border-radius: 4px;
  width: 193px;
  height: 40px;
  color: #FFFFFF;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnImport{
  background: #97BF61;
  border-radius: 4px;
  width: 193px;
  height: 40px;
  color: #FFFFFF;
  margin-left: 10px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.level-item{
  a{
    text-decoration: none;
  }
}
.form-group {
  position: relative;
  margin-bottom: 0;
  margin-right: 1rem;
  .form-control {
    padding: 5px 10px;
    box-shadow: none;
    &.is-invalid {
      background-image: none;
    }
    &:focus {
      border-color: theme-color(secondary)
    }
  }
  input {
    height: 40px;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    max-width: 100%;
    min-width: 20rem;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    padding-right: 2.8rem;
    padding-left: 0.5rem;
    outline: none;
  }
  .search-icon {
    width: 25px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 10px;
    cursor: pointer;
  }
}
.hidden-pagination {
  visibility: hidden;
}
.text-loading {
  color: #6d6d7778;
}
@media(max-width: 768px) {
  .form-group input{
    max-width: 100%;
    min-width: 100%;
  }
}
</style>
